<template>
  <div class="component-container">
    <h3>MSLNG2 Body Systems for Growth and Repair - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
      <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FAugust%202024%20Updates%2FMSLNG2_Activities1-6_10142024.zip?alt=media&token=6dcbad43-5a48-4037-abf0-8fa0b2b687c1" target="_blank">Teacher Presentations: Activities 1 - 6 (Updated 10/14/2024)</a></li>
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1UDUG9NwWVkzUoNyVV0w1LJVV6VXzuh3Ww0eZmGCellg/copy" target="_blank">MSLNG2 Body Systems for Growth and Repair Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/1IyJWTUFTpQ-1rOWTbjL_dKOZQVmIWJKT/view" target="_blank">MSLNG2 Body Systems for Growth and Repair Student Journal Answer Key</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
            <li><a href="https://docs.google.com/presentation/d/1OJWyxMBdulMsSpsypC0CwgEtpTNT2PcmbY8DuTotUqM/copy" target="_blank">The Broken Summer Booklet</a></li>
            <li><a href="https://docs.google.com/presentation/d/1w4StKUPOCAhALdBEPo7wPC2wKCkqlJHvGazYSil-gHs/copy" target="_blank">Anchor Charts</a></li>
            <li><a href="https://docs.google.com/presentation/d/1ZxVo1U-IFzKvSsyV1j9y3iPwK07vDrCTyxqKa013nrA/copy" target="_blank">What We Think Chart</a></li>
            <li><a href="https://docs.google.com/presentation/d/1IagpKD6qUAI_majlC5C9lqrAeEzC22DnvmWNdLsWSrI/copy" target="_blank">X-ray Card</a></li>
            <li><a href="https://docs.google.com/presentation/d/1wc4T0irPHA8TMNWgApotGQGiwU63H0OCdghM2qlbupk/copy" target="_blank">Microscope Know-How (Handouts)</a></li>
            <li><a href="https://docs.google.com/presentation/d/19b1qInH2UlRfLSF5hqfF9AkSh-SRkydiyIkuYkE5b9s/copy" target="_blank">Prepared Slides Card Set</a></li>
            <li><a href="https://docs.google.com/presentation/d/1fAYJM-1A9gxajvr2S_hNS9H7RnZAMhE8pRsGWZibQ5k/copy" target="_blank">Word Sort Cards - Lesson 2A</a></li>
            <li><a href="https://docs.google.com/presentation/d/1cR0mwjLRxryD3PQGfB9bvdde-l--QPrKi4nx6QKK9Ag/copy" target="_blank">Bone Structure Card</a></li>
            <li><a href="https://docs.google.com/presentation/d/1Zg-7HzjTv9iDVgcH3EDZXsHzVvO1HAOTPgwxLQzcaVs/copy" target="_blank">Bone Remodeling Card Set</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
        <h4 style="margin-left: 10px;">Videos</h4>
        <ul>
            <li><a href="http://drive.google.com/file/d/1Dwe4iHhfn73r2jBfeU1HKnjAT2DfBQms/view" target="_blank">Microscope Know-How: Viewing a Specimen</a></li>
            <li><a href="http://drive.google.com/file/d/1LrNpMYDKJZUzRM7PsyhDHl3X1Gk5Eh33/view" target="_blank">Microscope Know-How: Preparing a Slide</a></li>
            
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
